// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2004":"924ccec2f5bf23f4","2025":"d00baba949cbd2bf","2726":"da721f54715f24c3","3644":"f850cbf8081a81e0","9979":"761ab1275cf0dce6"}[chunkId] + ".js";
};